import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';

import ValueExpression from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';

export default new ValueExpression({
  identifier: 'lma-anomalies.wzf.ht-abholung.count',
  label: 'Anzahl Sendungen mit Hinweis auf WZF bei Haustürabholung',
  positiveDirection: PositiveDirection.custom,
});
